import { ReactElement } from 'react';

export { CheckboxFilter } from './CheckboxFilter';
export { DropdownFilter } from './DropdownFilter';
export { ComboboxFilter } from './ComboboxFilter';
export { TextSearchFilter } from './TextSearchFilter';
export { ToggleFilter } from './ToggleFilter';

export enum FilterCombineType {
  OR = 'OR',
  AND = 'AND',
  NOT = 'NOT',
}
export type FilterArrayType = {
  value: string | number | boolean | string[] | number[];
  label: string;
  filterKey: string;
  combineType?: FilterCombineType;
};

export interface FilterProps {
  filterKey: string;
}

export type FilterElement = ReactElement<FilterProps>;
